import { siteUrl } from '../metadata'

export function absoluteUrl(pathname) {
  if (!pathname) {
    return siteUrl
  }
  return `${siteUrl}${pathname}`
}
